import { D_D } from "../../Utils/CONSTANTS";
import { api } from "../AxiosInstance";

export function CreateDriverWithFileApi(data, DriverOrDistributor) {
  let address = ""
  if (DriverOrDistributor === D_D.DISTRIBUTOR) {
    address = "/api/DriverInfo/CreateDistributorWithFile"
  } else {
    address = "/api/DriverInfo/CreateDriverWithFile"
  }
  return api().post(address, data);
}

export function DeleteDriverApi(params) {
  return api().delete("/api/DriverInfo/Delete", { params });
}

export function EditDriverApi(data) {
  return api().put("/api/DriverInfo/Update", data);
}

export function CreateDriverWithVehicleApi(data) {
  return api().post("/api/DriverInfo/CreateDriverWithVehicle", data);
}

export function GetDriverApi(params) {
  return api().get("/api/DriverInfo/GetAllDriverOfTenant", { params });
}

export function getAllDriversOfPlanApi(params) {
  return api().get("/api/DriverInfo/GetAllDriversOfPlan", { params });
};

export function SearchTenantDriversApi(params) {
  return api().get("/api/DriverInfo/SearchTenantDrivers", { params });
}

export function SearchTenantDriverPersonalApi(params) {
  return api().get("/api/DriverInfo/SearchTenantDriverPersonal", { params });
}

//DISPATCHTOFRIVE
export function postDriverInfoApi(data) {
  return api().post("/api/Dispatch/AssignClusterToDriverTemporarily", data);
}

export function ActiveMissionToDriverApi(data) {
  return api().put("/api/Dispatch/ActiveMissionToDriver", data);
}

export function DeleteMissionFromDriverApi(data) {
  return api().post("/api/Dispatch/DeleteMissionFromDriverV2", data);
}

export function createDistributor(data) {
  return api().post("/api/DriverInfo/Create", data);
}

export function changeDriverPasswordApi(data) {
  return api().put("/api/DriverInfo/ChangePassword", data);
}
